import React from "react";
import { Box, IconButton, Paper, Stack } from "@mui/material";
import ReactCardFlip from "react-card-flip";
import { Cancel, Edit, Save } from "@mui/icons-material";
import styled from "styled-components";
import OrganisationalInfo from "./organisational-info";
import OrganisationalInfoEdit from "./organisational-info-edit";

const SectionTitle = styled.h2`
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    padding: 0;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const SectionTitleIcon = styled(Stack)`
    height: 22px;
    width: 22px;
    background: ${({ theme }) => theme.palette.background.paper};
    border-radius: 2px;
`;

const CardContainer = styled(Paper)`
    border-radius: 14px;
    border: ${({ theme, result }) => {
        if (result === "pending") return `2px solid ${theme.palette.text.disabled}`;
        if (result === "success") return `2px solid ${theme.palette.success.main}`;
        if (result === "failure") return `2px solid ${theme.palette.error.main}`;
        return `2px solid transparent`;
    }};
`;

const OrganisationalInfoCard = ({ user }) => {
    const [onEdit, setOnEdit] = React.useState(false);
    const [changes, setChanges] = React.useState({});
    const [saveResult, setSaveResult] = React.useState();

    const editRef = React.useRef();

    React.useEffect(() => {
        setTimeout(() => {
            if (saveResult === "success" || saveResult === "failure") setSaveResult(undefined);
        }, 500);
    }, [saveResult]);

    const hasChanges = () => !!Object.keys(changes).find((key) => !!changes[key]);

    const saveHandler = async () => {
        editRef.current.handleSubmit();
    };

    return (
        <>
            <Stack direction="row" justifyContent="space-between" pl={2} pr={2} pt={1} pb={1}>
                <SectionTitle>Personal Information</SectionTitle>
                <ReactCardFlip isFlipped={onEdit}>
                    <SectionTitleIcon direction="row" justifyContent="center" alignItems="center">
                        <IconButton
                            onClick={() => {
                                if (saveResult !== "pending") setOnEdit(true);
                            }}
                            aria-label="Edit Personal Information"
                        >
                            <Edit color="secondary" fontSize="small" />
                        </IconButton>
                    </SectionTitleIcon>
                    <Stack direction="row" justifyContent="space-between" spacing={1}>
                        {hasChanges() && (
                            <SectionTitleIcon
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <IconButton onClick={saveHandler}>
                                    <Save color="secondary" fontSize="small" />
                                </IconButton>
                            </SectionTitleIcon>
                        )}
                        <SectionTitleIcon
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <IconButton onClick={() => setOnEdit(false)}>
                                <Cancel color="secondary" fontSize="small" />
                            </IconButton>
                        </SectionTitleIcon>
                    </Stack>
                </ReactCardFlip>
            </Stack>
            <CardContainer result={saveResult}>
                <Box p={4}>
                    {onEdit ? (
                        <OrganisationalInfoEdit
                            changes={changes}
                            setChanges={setChanges}
                            setSaveResult={setSaveResult}
                            ref={editRef}
                            stopEdit={() => setOnEdit(false)}
                        />
                    ) : (
                        <OrganisationalInfo profileData={user} />
                    )}
                </Box>
            </CardContainer>
        </>
    );
};

export default OrganisationalInfoCard;
